import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import CallMadeIcon from "@mui/icons-material/CallMade";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteDiaologue from "./sub_comp/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import configs, { getParameterByName } from "../Constants";
import HomeIcon from "@mui/icons-material/Home";
import IconButton from "@mui/material/IconButton";
import MicrowaveIcon from '@mui/icons-material/Microwave';
import AppsIcon from "@mui/icons-material/Apps";
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Popup from "reactjs-popup";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MicrowaveRoundedIcon from '@mui/icons-material/MicrowaveRounded';
import Badge from "@mui/material/Badge";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "reactjs-popup/dist/index.css";
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import CampaignIcon from '@mui/icons-material/Campaign';
import TableBarIcon from '@mui/icons-material/TableBar';
import InventoryIcon from "@mui/icons-material/Inventory";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DesktopMacIcon from "@mui/icons-material/DesktopMac";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotificationsActiveSharpIcon from "@mui/icons-material/NotificationsActiveSharp";
import { ToastContainer, toast } from "react-toastify";
import SwitchButton from './sub_comp/SwitchButton';
import TableChartIcon from "@mui/icons-material/TableChart";
import Groups2Icon from "@mui/icons-material/Groups2";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import HelpIcon from "@mui/icons-material/Help";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import SyncIcon from "@mui/icons-material/Sync";
import QrCodeIcon from "@mui/icons-material/QrCode";
import BallotIcon from '@mui/icons-material/Ballot';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { clearApiCache } from "../apiCacheInterceptor";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import html2pdf from "html2pdf.js";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { Dialog, Divider } from "@mui/material";
import { useIntl } from "react-intl";
import { useUserPermissions } from "../context/UserPermissionsContext";
import PlanExpiryDialog from "./sub_comp/PlanExpiryDialog";
import { TextField } from "@mui/material";

function Nav(props) {
  const [open1, setOpen1] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [franchiseAnchorEl, setFranchiseAnchorEl] = React.useState(null);
  const [confirmNoMoreOrders, setConfirmNoMoreOrders] = React.useState(false);
  const [menuSearch, setMenuSearch] = React.useState("");
  const [branches, setBranches] = React.useState([]);
  const [userRole, setUserRole] = React.useState(null);
  let isPortrait = window.innerWidth < window.innerHeight;
  // Get permissions from context
  const { userPermissions, isLoading, userSevicePacks } = useUserPermissions();

  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  console.log(userData);
  const [qRPath, setQRPath] = useState("");
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableService, setTableService] = useState([]);
  const [tableNumber, setTableNumber] = useState(0);
  const [settingInfo, setSettingInfo] = useState(null);
  const userId = userData ? (userData.isIAM ? userData.parentUser : userData.sub) : "";
  const [selectedBranchId, setSelectedBranchId] = useState(localStorage.getItem("selectedBranchId"));
  const paymentTerminals = [
    { name: 'Fygaro(Test mode)', value: "https://www.fygaro.com" },
    { name: 'Fygaro(Production mode)', value: "https://www.fygaro.com" },
    { name: 'Verifone(Test mode)', value: "https://vcloud-dev.alt-payment.com" },
    { name: 'Verifone(Production mode)', value: "https://vcloud.alt-payment.com" },
  ];

  // merchantData
  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const merchantInParam = getParameterByName("merchantCode");

  const merchCode =
    merchantData && merchantData.merchantCode
      ? merchantData.merchantCode
      : merchantInParam;
  // const closeModal = () => setPopUpOpen(false);

  let baseURL = configs.baseURL;
  let authApiServer = configs.authapi;
  const getTabByUser = baseURL + "/api/tables?merchantCode=" + merchCode;

  const token = getParameterByName("token") || localStorage.getItem("token");

  useEffect(() => {
    if (userId && userId !== " " && userData?.role?.toUpperCase() == 'FRANCHISE-ADMIN') {
      const token = localStorage.getItem("token");

      axios.get(`${authApiServer}/user/members?userid=${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(response => {
          const filteredMembers = response.data.filter(member => !member.isIAM);
          setBranches(filteredMembers);


          // Set role directly from userData
          const userRole = userData && userData.role;
          if (userRole) {
            console.log("Using user role from session:", userRole);
            setUserRole(userRole);
          }
        })
        .catch(error => {
          console.error("Error fetching members:", error);
        });
    }
  }, [userId, authApiServer]);

  const paramPath = merchantInParam ? "merchantCode=" + merchCode : "";
  const homePath = `/dashboard?${paramPath}`;
  const catPath = `/categories?${paramPath}`;
  const varPath = `/varieties?${paramPath}`;
  const orderListPath = `/orderList?${paramPath}`;
  const productPath = `/productDetails?${paramPath}`;
  const productPathmember = `/productDetailsmember?${paramPath}`;
  const tablemember = `/tableMember?${paramPath}`;
  const tabPath = `/table?${paramPath}`;
  const reportsPath = `/reports?${paramPath}`;
  const settingPath = `/setting?${paramPath}`;
  const posPath = `/epos?${paramPath}`;
  const memberPath = `/members?${paramPath}`;
  const customerPath = `/customers?${paramPath}`;
  const { formatMessage: t, locale, setLocale } = useIntl();
  const [pairFormOpen, setPairFormOpen] = useState(false);
  const [pairDialogOpen, setPairDialogOpen] = useState(false);
  const [registerId, setRegisterId] = useState("");
  const [userInfo, setUserInfo] = useState(null);
  const [terminalServiceName, setTerminalServiceName] = useState("");
  const [terminalKey, setTerminalKey] = useState("");
  const [terminalEndpoint, setTerminalEndpoint] = useState("");


  const getSettings = () => {
    console.log(userId);
    if (!userId) return; // Prevent API call if userId is missing
    const token = localStorage.getItem("token");
    axios
      .get(`${baseURL}/api/settings/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.length) {
          console.log(res.data);
          setSettingInfo(res.data[0]);
          res.data[0]?.bizVertical.toLowerCase() == 'restaurant' && getTables();
        }
      })
      .catch((error) => {
        console.log("User settings not found", error);
      });

  }
  useEffect(() => {
    getSettings();
  }, [userId]);

  const getTables = () => {
    axios
      .get(getTabByUser)
      .then((response) => {
        console.log(response.data);
        setTableData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching table data:", error);
      });
  }


  const handleConfirmCloseForBillings = () => {
    const token = localStorage.getItem("token");
    axios
      .patch(
        `${baseURL}/api/settings/${settingInfo?.id}`,
        {
          isOpen: false,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        toast.error('CLOSED NOW!');
        getSettings();
      });
    setConfirmNoMoreOrders(false);

  };

  // Handle field update
  const handleFieldUpdate = (key, newValue) => {
    const token = localStorage.getItem("token");
    setSettingInfo((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    axios
      .patch(
        `${baseURL}/api/settings/${settingInfo.id}`,
        { [key]: newValue },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        console.log("Updated response: " + res);
        toast.success("Settings updated successfully");
      })
      .catch((err) => {
        toast.error("Failed to update settings");
        console.error(err);
      });
  };

  const handleNotification = () => {
    setOpen1(true);
    setTableNumber(0);
    // setTimeout(() => {
    //   setOpen1(false);
    //   setTableService([]);
    // }, 1000);
  };
  const handleSync = async () => {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('cache_')) localStorage.removeItem(key);
    });

    try {
      await clearApiCache();
    } catch (e) {
      console.warn("Failed to clear IDB cache during sync", e);
    }

    toast.success("Syncing with live server...");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("userData");
    localStorage.removeItem("selectedBranchId");
    localStorage.removeItem("merchantData");
    localStorage.removeItem('branch-merchants');
    //  window.location.reload();
    // http://localhost:8080/
    let isMember = localStorage.getItem('isMember');
    if (isMember) {
      localStorage.removeItem("merchantData");
      localStorage.removeItem('isMember')
      window.location.href = `${window.location.origin}/?${window.location.href.split('?')[1]}&logout=true`;
    } else {
      window.location.href =
        configs.authUrl + "/account/login?redirect=" + window.location.origin + "&logout=true";
      //  window.location.href ="http://localhost:8080/account/login?redirect="+window.location.origin
    }
  };

  const open = Boolean(anchorEl);
  const franchiseMenuOpen = Boolean(franchiseAnchorEl);

  const handleClick = () => {
    setAnchorEl(true);
  };
  const handleOpen = () => {
    console.log("election");
    setPopUpOpen(true);

  };
  const handleClose = () => {
    setAnchorEl(false);
  };

  const handleFranchiseClick = (event) => {
    setFranchiseAnchorEl(event.currentTarget);
  };

  const handleFranchiseClose = () => {
    setFranchiseAnchorEl(null);
  };

  const handleBranchSelect = (member) => {
    setSelectedBranchId((member && member.id) || "");
    localStorage.setItem("selectedBranchId", ((member && member.id) || ""));
    handleFranchiseClose();
    window.location.reload();
  };

  let cmsUrl = `${configs.cmsUrl}`;
  //console.log('cms',cmsUrl);

  const canBeOpen = open1 && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;

  const handleClosePopup = () => setPopUpOpen(false);
  const handlePopupClose = () => setOpen1(false);
  const navigate = useNavigate()
  const handleDashboard = () => {
    navigate("/" + (merchantInParam ? "?merchantCode=" + merchantInParam : ""));
  }
  console.log(userSevicePacks);
  const getSelectedBranchName = () => {
    let selBrch = branches.filter(branch => branch.id == selectedBranchId);
    return selBrch[0].firstName + " " + selBrch[0].lastName;
  }
  useEffect(() => {
    const tab = tableData && tableData.length ? tableData.filter((table) => table.isServiceCall === true) : "";
    console.log(tab);
    setTableService(tab);
    setTableNumber(tab.length);
  }, [tableData]);

  const isMember = localStorage.getItem('isMember');

  // No need to store userPermissions in localStorage anymore
  // The context API handles sharing the permissions data

  // Helper function for navigation - no need to store permissions anymore
  const handleNavigate = () => {
    handleClosePopup();
  };

  const handleCheckboxChange = async (key) => {
    if (settingInfo && settingInfo?.isOpen) {
      setConfirmNoMoreOrders(true);
    } else {
      setConfirmNoMoreOrders(false);

      const token = localStorage.getItem("token");
      const updatedValue = settingInfo && !settingInfo[key];
      setSettingInfo((prev) => ({
        ...prev,
        [key]: updatedValue,
      }));

      try {
        await axios.patch(
          `${baseURL}/api/settings/${settingInfo?.id}`,
          {
            [key]: updatedValue,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        toast.success('OPEN NOW!');


      } catch (error) {
        toast.error(`Failed to update ${key}`);
        console.error("Error updating field:", error);
      }
    }
  };

  return (
    <div
      id="navBar"
      className="text-center m-2 "
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span
        className="logo"
        style={{
          backgroundImage: `url(${merchantData ? merchantData.logoImg : ""})`,
        }}
        onClick={handleDashboard}
      ></span>
      <div>
        {/*<NavLink exact to="/dashboard"><HomeIcon   sx={{ fontSize: 40,color:"black",paddingTop:'5px'}}/></NavLink>*/}
        {/* <div><AppsIcon onClick={()=>setPopUpOpen(true)}  sx={{ fontSize: 40}}/></div> */}
        <AppsIcon
          sx={{ fontSize: 40, cursor: "pointer" }}
          onClick={handleOpen}
        />
        <Popup
          position="bottom left"
          id="popup"
          open={popUpOpen}
          onClose={handleClosePopup}
          disableAutoFocus disableEnforceFocus
        >
          <div className="menu-link" style={{ backgroundColor: merchantData?.themeColor, display: "flex", flexDirection: "column", alignItems: "center" }}>
            {/* Dummy focusable element to catch reactjs-popup autofocus before it hits the TextField, so it doesn't break barcode scanners */}
            <button style={{ width: 0, height: 0, opacity: 0, position: 'absolute', overflow: 'hidden', padding: 0, border: 'none' }} aria-hidden="true" tabIndex={0}></button>
            <TextField
              placeholder="Search..."
              variant="outlined"
              size="small"
              fullWidth
              value={menuSearch}
              onChange={(e) => setMenuSearch(e.target.value)}
              autoFocus={false}
              sx={{
                margin: "5px",
                padding: "10px",
                width: "200px"
              }}
            />
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
              {t({ id: "dashboard" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                <NavLink
                  exact
                  to={homePath}
                  style={{ border: "none", textAlign: "center" }}
                  onClick={handleClosePopup}
                >
                  <HomeIcon sx={{ fontSize: "50px", cursor: "pointer", border: "none", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "dashboard" })}</label>
                </NavLink>
              )}

              {userSevicePacks?.pos?.enabled && userPermissions.IS_CATEGORY_VIEW && t({ id: "categories" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                <NavLink
                  exact
                  to={catPath}
                  style={{ border: "none", textAlign: "center" }}
                  onClick={handleClosePopup}
                >
                  <InventoryIcon sx={{ fontSize: "50px", cursor: "pointer", border: "none", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "categories" })}</label>
                </NavLink>
              )}

              {userSevicePacks?.pos?.enabled && userPermissions.IS_ITEMS_VIEW && t({ id: "items" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={productPath}
                  style={{ border: "none", textAlign: "center" }}
                  onClick={handleClosePopup}
                >
                  <AccountTreeIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "items" })}</label>
                </NavLink>
              )}

              {userSevicePacks?.pos?.enabled && userPermissions.IS_ORDERS_VIEW && t({ id: "orders" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={orderListPath}
                  style={{ border: "none", textAlign: "center" }}
                  onClick={handleClosePopup}
                >
                  <ListAltIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "orders" })}</label>
                </NavLink>
              )}

              {userSevicePacks?.pos?.enabled && userPermissions.IS_POS_VIEW && "pos".includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={posPath}
                  onClick={() => {
                    props.setIsEpos(true);
                    setPopUpOpen(false);
                  }}
                  style={{ border: "none", textAlign: "center" }}
                >
                  <DesktopMacIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>POS</label>
                </NavLink>
              )}

              {
                userSevicePacks?.pos?.enabled &&
                (userSevicePacks?.ttoApp?.enabled || userSevicePacks?.ttoQR?.enabled) &&
                userPermissions.IS_TABLES_VIEW && t({ id: "tables" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={tabPath}
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={handleClosePopup}
                  >
                    <TableBarIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "tables" })}</label>
                  </NavLink>
                )}

              {
                userSevicePacks?.inventoryManagement?.enabled &&
                userPermissions.IS_INVENTORY_VIEW && "inventories".includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={"/inventories"}
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={handleClosePopup}
                  >
                    <BallotIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>Inventories</label>
                  </NavLink>
                )}

              {
                (userSevicePacks?.advanceReports?.enabled || userSevicePacks?.basicReports?.enabled) &&
                userPermissions.IS_REPORTS_VIEW && t({ id: "reports" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={reportsPath}
                    style={{ border: "none", textAlign: "center" }}
                    onClick={handleClosePopup}
                  >
                    <BarChartIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "reports" })}</label>
                  </NavLink>
                )}

              {
                userSevicePacks?.members?.enabled &&
                userPermissions.IS_MEMBER_VIEW && t({ id: "member" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={memberPath}
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={handleClosePopup}
                  >
                    <Groups2Icon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "member" })}</label>
                  </NavLink>
                )}

              {
                userSevicePacks?.customers?.enabled &&
                userPermissions.IS_CUSTOMER_VIEW && t({ id: "customers" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={customerPath}
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={handleClosePopup}
                  >
                    <AccountBoxIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "customers" })}</label>
                  </NavLink>
                )}

              {userSevicePacks?.pos?.enabled &&
                userPermissions.IS_VARIETY_VIEW && t({ id: "varieties" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={varPath}
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={handleClosePopup}
                  >
                    <StackedBarChartIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "varieties" })}</label>
                  </NavLink>
                )}

              {userSevicePacks?.multikitchen?.enabled &&
                userPermissions.IS_KITCHEN_VIEW && t({ id: "kitchen" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={"/kitchen"}
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={handleClosePopup}
                  >
                    <MicrowaveIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "kitchen" })}</label>
                  </NavLink>
                )}

              {userPermissions.IS_QR_CODES_VIEW && "qr codes".includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={"/qrcodes"}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={handleClosePopup}
                >
                  <QrCodeScannerIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <div style={{ color: merchantData?.themeTxtColor }}>QR Codes</div>
                </NavLink>
              )}

              {
                userPermissions.IS_NOTIFICATION_VIEW && t({ id: "notification" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    onClick={() => {
                      handleNotification();
                      setPopUpOpen(false);
                      handleClose();
                    }}
                    style={{ border: "none", textAlign: "center" }}
                  >
                    <NotificationsActiveSharpIcon sx={{ fontSize: 50, cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "notification" })}</label>
                  </NavLink>
                )}

              {userPermissions.IS_PROMOTION_VIEW && t({ id: "promotion" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={"/promotion"}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={handleClosePopup}
                >
                  <CampaignIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "promotion" })}</label>
                </NavLink>
              )}

              {userPermissions.IS_PROMOTION_VIEW && "offers".includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={"/offers"}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={handleClosePopup}
                >
                  <LocalOfferIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>Offers</label>
                </NavLink>
              )}

              {
                userSevicePacks?.digitalSignage?.enabled &&
                userPermissions.IS_CMS_VIEW && t({ id: "digi_signage" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                  <NavLink
                    to={`${cmsUrl}`}
                    target="_blank"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      textAlign: "center",
                    }}
                  >
                    <PersonalVideoIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                    <div style={{ color: merchantData?.themeTxtColor }}>{t({ id: "digi_signage" })}</div>
                  </NavLink>
                )}

              {"apps".includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={"/app"}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={handleClosePopup}
                >
                  <InstallMobileIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>Apps</label>
                </NavLink>
              )}

              {/* Help is always available */}
              {t({ id: "help" }).toLowerCase().includes(menuSearch.toLowerCase()) && (
                <NavLink
                  to={"/help"}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={handleClosePopup}
                >
                  <HelpIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor }}>{t({ id: "help" })}</label>
                </NavLink>
              )}

              {"sync".includes(menuSearch.toLowerCase()) && (
                <NavLink
                  style={{ textDecoration: "none", color: "black", cursor: "pointer" }}
                  onClick={() => { handleSync(); handleClosePopup(); }}
                >
                  <SyncIcon sx={{ fontSize: "50px", cursor: "pointer", color: merchantData?.themeTxtColor }} />
                  <label style={{ color: merchantData?.themeTxtColor, cursor: "pointer" }}>Sync Data</label>
                </NavLink>
              )}
            </div>
          </div>
        </Popup>

      </div>
      <div
        id="qr-img"
        style={{
          visibility: "hidden",
          border: "1px dotted",
          padding: "10px",
          margin: "10px",
          textAlign: "center",
          position: "absolute",
          top: "20px",
          background: "#52d55a",
        }}
      >
        <h1 style={{ fontSize: "2.7rem" }}>{"SCAN TO ORDER"}</h1>
        <QRCode
          id="qrcode"
          size={556}
          style={{
            height: "300px",
            width: "300px",
          }}
          value={qRPath}
        />
        <h1>{"SELF SERVICE QR"}</h1>
        <p>{"Scan with Mobile Camera"}</p>
        <p>{"[Gogle LENS, Scanner etc]"}</p>
      </div>

      <div
        id={"qr-img-onlymen"}
        style={{
          visibility: "hidden",
          border: "2px dotted",
          padding: "10px",
          margin: "2px",
          textAlign: "center",
          position: "absolute",
          top: "20px",
          background: "#52d55a",
        }}
      >
        <h1 style={{ fontSize: "2.7rem" }}>{"SCAN FOR MENU"}</h1>
        <QRCode
          id="qrcode"
          size={556}
          style={{
            height: "300px",
            width: "300px",
          }}
          value={qRPath}
        />

        <p>{"Scan with Mobile Camera"}</p>
        <p>{"[Gogle LENS, Scanner etc]"}</p>
      </div>
      {/*  */}
      <span className="nav-links">
        {userData && userData.role === "FRANCHISE-ADMIN" && branches.length > 0 && (
          <div className="franchise-dropdown">
            <Button
              className="franchise-selector"
              onClick={handleFranchiseClick}
              aria-controls={franchiseMenuOpen ? "franchise-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={franchiseMenuOpen ? "true" : undefined}
              endIcon={<KeyboardArrowDownIcon />}
            >
              {!selectedBranchId ? (userData.firstName + " " + userData.lastName) : getSelectedBranchName()

              }
            </Button>
            <Menu
              id="franchise-menu"
              anchorEl={franchiseAnchorEl}
              open={franchiseMenuOpen}
              onClose={handleFranchiseClose}
              MenuListProps={{
                "aria-labelledby": "franchise-selector",
              }}
            >
              <MenuItem
                onClick={handleBranchSelect}
                selected={!selectedBranchId}
              >
                {(userData.firstName + " " + userData.lastName)}
              </MenuItem>
              {branches.length > 0 && (
                <Divider sx={{ my: 1 }} />
              )}
              {branches.length > 0 && (
                <MenuItem disabled sx={{ opacity: 1, fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>

                </MenuItem>
              )}

              {branches.map((branch) => (
                <MenuItem
                  key={branch.id}
                  onClick={() => handleBranchSelect(branch)}
                  selected={selectedBranchId === branch.id}
                  sx={{ pl: 2 }}
                >
                  {(branch.firstName + ' ' + branch.lastName) || "Branch"}
                </MenuItem>
              ))}
            </Menu>
          </div>
        )}

        {userData && <NavLink to={orderListPath} style={{ backgroundColor: merchantData?.themeColor, color: merchantData?.themeTxtColor }} className="cont">
          {t({ id: "orders" })}
        </NavLink>}
        {userData && userData.role != "SUPER-ADMIN" && userSevicePacks?.pos?.enabled && <NavLink
          to={posPath}
          style={{ backgroundColor: merchantData?.themeColor, color: merchantData?.themeTxtColor, marginLeft: "10px" }}
          onClick={() => props.setIsEpos(false)}
        >
          {t({ id: "new_order" })}
        </NavLink>}
      </span>

      {false && userSevicePacks?.pos?.enabled && <div class="hinge-center-container"><img
        height="50px"
        width="50px"
        alt=""
        className="hinge-center"
        src={settingInfo?.isOpen ? "/open-sign.png" : "/closed.png"}
        onClick={() => handleCheckboxChange('isOpen')}
      /></div>}

      {false && <div>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={tableNumber} color="error">
            <NotificationsIcon onClick={handleNotification} />
          </Badge>
        </IconButton>
      </div>}
      {!isPortrait && <div className="logout">
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          style={{ color: "black", marginTop: "5px" }}
        >
          {/* <MoreVertIcon/> */}
          <div><span style={{ fontSize: "15px" }} id="name">
            {userData ? userData.firstName : ""}
          </span><br />
            <span
              style={{
                fontSize: "9px",
                backgroundColor: "#0e0e0eff",
                borderRadius: "6px",
                color: "#fff",
                padding: "3px 8px",
                width: "fit-content",
              }}
            >
              {userData?.plan?.planName}
            </span></div>
          <AccountCircleOutlinedIcon sx={{ fontSize: 40 }} />
          <ExpandMoreIcon />
        </Button>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          autoFocus={true}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {/* <MenuItem onClick={handleClose}>
                   <NavLink to={reportsPath} style={{textDecoration:"none",color:"black"}} >Reports</NavLink>
        </MenuItem> */}

          {/* <MenuItem onClick={handleClose}>
        <NavLink to={tabPath}   style={{textDecoration:"none",color:"black"}}>Table View</NavLink>
        </MenuItem>

        <MenuItem onClick={handleClose}>
        <NavLink to="/customers"   style={{textDecoration:"none",color:"black"}}>Customers</NavLink>
        </MenuItem> */}


          {!merchantInParam && (
            <>
              <MenuItem
                onClick={handleClose}
              > <NavLink
                to={memberPath}
                style={{ textDecoration: "none", color: "black" }}

              >
                  User Profile
                </NavLink>

              </MenuItem>
              <MenuItem onClick={handleClose}>
                <NavLink
                  to={settingPath}
                  style={{ textDecoration: "none", color: "black" }}
                >
                  Setting
                </NavLink>
              </MenuItem>
            </>)}

          <MenuItem onClick={() => {
            setTerminalEndpoint(paymentTerminals[0].value);
            setTerminalServiceName(settingInfo?.payTerminal?.verifone?.serviceName || "NextOrder");
            setTerminalKey(settingInfo?.payTerminal?.verifone?.key || "378d7486-97d2-4786-a97c-6eca4a3df181");
            setPairFormOpen(true);
          }}>Pair Terminal</MenuItem>
          <MenuItem onClick={handleSync}>Sync Data</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </div>}

      <DeleteDiaologue
        msg="close"
        open={false && confirmNoMoreOrders}
        onClose={() => false && setConfirmNoMoreOrders(false)}
        onConfirm={() => false && handleConfirmCloseForBillings()}
        itemName={"billing for the day"}
      />

      <Dialog
        open={open1}
        style={{ top: "2%", height: "auto !important" }}
        onClose={handlePopupClose}
      >

        <Box sx={{ border: 1, p: 1, bgcolor: "background.paper" }}>
          <div>
            {tableService &&
              tableService.map((service) => (
                <div style={{ padding: "10px" }}>
                  <div
                    key={service.number}
                    style={{
                      padding: "5px",
                      backgroundColor: "antiquewhite",
                    }}
                  >
                    Table <b>{service.number}</b> is calling for{" "}
                    <b>Service</b>
                  </div>
                </div>
              ))}
            {tableService && tableService.length === 0 && "No Notification"}
          </div>
        </Box>
      </Dialog>
      <Dialog open={pairFormOpen} onClose={() => setPairFormOpen(false)}>
        <div style={{ padding: "20px", minWidth: "300px" }}>
          <h3>Pair Payment Terminal</h3>
          <select
            style={{ padding: "10px", marginBottom: "20px", width: "100%" }}
            value={terminalEndpoint}
            onChange={(e) => setTerminalEndpoint(e.target.value)}
          >
            {
              paymentTerminals.map(pt => <option key={pt.name} value={pt.value}>{pt.name}</option>)
            }
          </select>
          <TextField
            fullWidth
            label="Service name"
            value={terminalServiceName}
            onChange={(e) => setTerminalServiceName(e.target.value)}
            style={{ marginBottom: "10px" }}
          />

          <TextField
            fullWidth
            label="Key"
            value={terminalKey}
            onChange={(e) => setTerminalKey(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <Button
            variant="outlined"
            onClick={() => {
              handleFieldUpdate("payTerminal", {
                verifone: {
                  endpoint: terminalEndpoint,
                  serviceName: terminalServiceName,
                  key: terminalKey
                }
              });
              setPairDialogOpen({
                endpoint: terminalEndpoint,
                serviceName: terminalServiceName,
                key: terminalKey
              });
              setPairFormOpen(false);
            }}

          >
            Continue
          </Button>
        </div>
      </Dialog>
      <Dialog open={pairDialogOpen} onClose={() => setPairDialogOpen(false)} maxWidth="lg">
        <div style={{ width: "500px", height: "500px" }}>
          <iframe
            src={pairDialogOpen?.endpoint + '/webint/config/' + pairDialogOpen.serviceName + '/' + pairDialogOpen?.key + '?register_id=' + merchantData?.firstName + '&merchant_id=' + merchantData?.merchantCode + '&merchant_name=' + userInfo?.firstName} frameborder="0" allowtransparency="true"
            style={{ width: "100%", height: "100%" }}
            frameBorder="0"
          ></iframe>
        </div>
      </Dialog>
      <PlanExpiryDialog
        userData={userData}
        themeColor={merchantData?.themeColor}
        navigate={navigate}
      />
    </div>
  );
}

export default Nav;
